import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchAllReports, processReport } from '../../slices/reportsSlice';
import { styles } from '../Topics/TopicStyles';
import axios from 'axios';

const AdminDashboard = () => {
  const dispatch = useDispatch();
  const { reports, stats, loading } = useSelector(state => state.reports);

  const [isMaintenance, setIsMaintenance] = useState(false);

  useEffect(() => {
    dispatch(fetchAllReports());
    fetchSystemStatus();
  }, [dispatch]);

  // 🚩 [추가] 서버에서 현재 점검 상태 가져오기
  const fetchSystemStatus = async () => {
    try {
      const token = localStorage.getItem('token');
      const res = await axios.get('https://the-pivot-logical-battleground.onrender.com/api/admin/dashboard', {
          headers: { Authorization: `Bearer ${token}` }
      });
      // admin/dashboard API가 system 객체를 반환하도록 백엔드 수정됨
      if (res.data.system) {
        setIsMaintenance(res.data.system.isUnderMaintenance);
      }
    } catch (err) {
      console.error("시스템 상태 확인 실패:", err);
    }
  };

  // 🚩 [추가] 점검 모드 토글 핸들러
  const toggleMaintenance = async () => {
    const msg = isMaintenance 
      ? "점검 모드를 해제하시겠습니까? \n이제 유저들이 다시 접속할 수 있습니다." 
      : "🚨 [긴급] 사이트를 점검 모드로 전환하시겠습니까? \n모든 유저의 접속이 차단됩니다. (관리자는 접속 가능)";
    
    if (!window.confirm(msg)) return;

    try {
        const token = localStorage.getItem('token');
        const res = await axios.post('https://the-pivot-logical-battleground.onrender.com/api/admin/toggle-maintenance', {}, {
            headers: { Authorization: `Bearer ${token}` }
        });
        setIsMaintenance(res.data.isUnderMaintenance);
        alert(res.data.message);
    } catch (err) {
        alert("처리 실패: " + err.message);
    }
  };

  const handleAdminAction = (targetId, targetType, action) => {
    const msg = action === 'APPROVE' ? "신고를 승인(블라인드 유지)하시겠습니까?" : "신고를 반려(콘텐츠 복구)하시겠습니까?";
    if (window.confirm(msg)) {
      dispatch(processReport({ targetId, targetType, action }))
        .unwrap()
        .then((res) => alert(res.message))
        .catch(err => alert(err));
    }
  };

  if (loading) return <div style={styles.loading}>데이터 로드 중...</div>;

  console.log("data", {reports, stats});

  return (
    <div style={styles.container}>
      <div style={styles.adminWrapper}>
        <h1 style={styles.title}>관리자 관제탑</h1>

        {/* 🚩 [추가] 비상 정지 버튼 */}
        <button 
            onClick={toggleMaintenance}
            style={{
                backgroundColor: isMaintenance ? '#00d4ff' : '#ff4e50', // 켜져있으면 파란색(해제), 꺼져있으면 빨간색(발동)
                color: isMaintenance ? '#000' : '#fff',
                border: 'none',
                padding: '10px 20px',
                borderRadius: '8px',
                fontWeight: 'bold',
                cursor: 'pointer',
                boxShadow: isMaintenance ? '0 0 10px #00d4ff' : '0 0 15px #ff4e50',
                fontSize: '1rem'
            }}
        >
            {isMaintenance ? "🟢 점검 모드 해제 (오픈)" : "🚨 긴급 점검 모드 발동"}
        </button>

        {/* 1. 요약 통계 */}
        {stats && (
          <div style={styles.statsGrid}>
            <div style={styles.statCard}>
              <h3 style={{color: '#888'}}>전체 논객</h3>
              <p style={{fontSize: '1.5rem', fontWeight: 'bold'}}>{stats.totalUsers}명</p>
            </div>
            <div style={{...styles.statCard, borderTop: '4px solid #00d4ff'}}>
              <h3 style={styles.blueText}>BLUE 진영</h3>
              <p style={{fontSize: '1.5rem'}}>{stats.blueUsers}명</p>
            </div>
            <div style={{...styles.statCard, borderTop: '4px solid #ff4e50'}}>
              <h3 style={styles.redText}>RED 진영</h3>
              <p style={{fontSize: '1.5rem'}}>{stats.redUsers}명</p>
            </div>
          </div>
        )}

        {/* 2. 신고 관리 목록 */}
        <h2 style={{borderBottom: '1px solid #333', paddingBottom: '10px'}}>신고 관리 목록</h2>
        <div style={{marginTop: '20px'}}>
          {reports?.posts?.length === 0 && <p style={{color:'#666'}}>신고된 게시글이 없습니다.</p>}
          {reports?.posts?.map(post => (
            <div key={post._id} style={{...styles.postCard, border: post.isBlocked ? '1px solid #ff4e50' : '1px solid #333', cursor: 'default', marginBottom: '20px'}}>
              <div style={{display:'flex', justifyContent:'space-between', marginBottom: '10px'}}>
                <span style={post.faction === 'BLUE' ? styles.blueText : styles.redText}>
                  [{post.faction}] {post.authorId?.nickname} 논객 | 🚩 신고: {post.reportCount}회
                </span>
                <div style={styles.actionButtons}>
                  <button onClick={() => handleAdminAction(post._id, 'Post', 'REJECT')} style={styles.rejectBtn}>정상 복구</button>
                  <button onClick={() => handleAdminAction(post._id, 'Post', 'APPROVE')} style={styles.approveBtn}>신고 승인</button>
                </div>
              </div>
              <p style={{...styles.postContent, color: post.isBlocked ? '#ff4e50' : '#ccc', backgroundColor: '#000', padding: '10px'}}>
                {post.isBlocked && <strong>[블라인드됨] </strong>}
                {post.content}
              </p>
            </div>
          ))}
        </div>

        {/* 3. 신고된 댓글 관리 목록 */}
        <h2 style={{borderBottom: '2px solid #333', paddingBottom: '10px', marginTop: '50px'}}>💬 요주의 분석 (댓글)</h2>
        <div style={{marginTop: '20px'}}>
          {reports?.comments?.length === 0 && <p style={{color:'#666'}}>신고된 댓글이 없습니다.</p>}
          {reports?.comments?.map(comment => (
            <div key={comment._id} style={{...styles.commentItem, borderLeft: comment.faction === 'BLUE' ? '4px solid #00d4ff' : '4px solid #ff4e50', marginBottom: '15px'}}>
              <div style={{display:'flex', justifyContent:'space-between'}}>
                <span style={{fontSize: '0.9rem', color: '#888'}}>작성자: {comment.nickname} | 🚩 신고: {comment.reportCount}회</span>
                <div style={styles.actionButtons}>
                  <button onClick={() => handleAdminAction(comment._id, 'Comment', 'REJECT')} style={{...styles.rejectBtn, fontSize: '0.7rem'}}>복구</button>
                  <button onClick={() => handleAdminAction(comment._id, 'Comment', 'APPROVE')} style={{...styles.approveBtn, fontSize: '0.7rem'}}>승인</button>
                </div>
              </div>
              <p style={{marginTop: '5px', color: comment.isBlocked ? '#ff4e50' : '#fff'}}>{comment.content}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;